import React, { useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import best1 from "../Images/2024.png";
import best from "../Images/2024div.png";
import about from "../Images/about.png";
import bgwhite from "../Images/Frame.png";
import HomeHero from "../Images/Graphics PNG/home.png";
import icon1 from "../Images/icon1.png";
import icon2 from "../Images/icon2.png";
import icon3 from "../Images/icon3.png";
import icon4 from "../Images/icon4.png";
import logo1 from "../Images/Logos/LogosSlider/Vector-1.png";
import logo2 from "../Images/Logos/LogosSlider/Vector-2.png";
import logo3 from "../Images/Logos/LogosSlider/Vector-3.png";
import logo4 from "../Images/Logos/LogosSlider/Vector-4.png";
import logo5 from "../Images/Logos/LogosSlider/Vector-5.png";
import logo6 from "../Images/Logos/LogosSlider/Vector-6.png";
import logo from "../Images/Logos/LogosSlider/Vector.png";
import bgteal from "../Images/tealback.png";

import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import WhyChooseUs from "../Components/HomeWhyChooseUs";
import TypewriterText from "../Components/TypeWriterText";
// import Frametrusted from "../Images/Frametrusted.png"
import uparrow from "../Images/Arrows/upleftteal.png";
import downarrow from "../Images/Arrows/uprightteal.png";
const HomePage = () => {
  // State to track if the stats section is in view
  const [statsInView, setStatsInView] = useState(false);
  const [aboutInView, setAboutInView] = useState(false);

  // State to trigger the counting animation
  const { ref: statsRef, inView } = useInView({
    triggerOnce: false, // Remove triggerOnce to trigger every time the section comes into view
    threshold: 0.3, // Adjust this value to trigger when 50% of the section is visible
    onChange: (inView) => {
      if (inView) {
        setStatsInView(true); // Set state to true when section is in view
      } else {
        setStatsInView(false);
      }
    },
  });

  // State to trigger the counting animation
  const { ref: aboutRef, InView } = useInView({
    triggerOnce: false, // Remove triggerOnce to trigger every time the section comes into view
    threshold: 0.5, // Adjust this value to trigger when 50% of the section is visible
    onChange: (InView) => {
      if (InView) {
        setAboutInView(true); // Set state to true when section is in view
      } else {
        setAboutInView(false);
      }
    },
  });

  const logos = [logo, logo1, logo2, logo3, logo4, logo5, logo6];

  // Slider settings
  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 3, // Show 3 cards at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: false,
    dotClass: "custom-dots",

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, // Show 2 cards at a time for medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1, // Show 1 card at a time for small screens
          slidesToScroll: 1,
        },
      },
    ],
  };
  const features = [
    {
      title: "SEO Optimization",
      description:
        "Boost your website's visibility with our expert SEO services. We ensure you rank higher, attract quality traffic, and convert visitors into loyal customers.",
      icon: (
        <img
          src={icon1}
          className="w-12 h-12 mb-0 text-teal-700 "
          alt="SEO Optimization Service"
        />
      ),
      imgAlt: "SEO Optimization Service",
    },
    {
      title: "Branding",
      description:
        "Create a brand identity that resonates with your audience. Our branding services craft unique, memorable experiences that set you apart in the market.",
      icon: (
        <img
          src={icon4}
          className="w-12 h-12 mb-0 text-teal-700 "
          alt="Branding"
        />
      ),
      imgAlt: "Branding",
    },
    {
      title: "Social Media Marketing",
      description:
        "Boost your brand's reach with customized digital marketing and targeted social media campaigns. We connect you with the right audience, driving engagement and conversions.",
      icon: (
        <img
          src={icon3}
          className="w-12 h-12 mb-0 text-teal-700 "
          alt="Social Media Marketing Service"
        />
      ),
      imgAlt: "Social Media Marketing Service",
    },
    {
      title: "Social Media Management",
      description:
        "Optimize your online presence with consistent social media management. We handle content, engagement, and analytics to grow your community and enhance your brand.",
      icon: (
        <img
          src={icon2}
          className="w-12 h-12 mb-0 text-teal-700 "
          alt="Social Media Management Service"
        />
      ),
      imgAlt: "Social Media Management Service",
    },
    {
      title: "Video Editing",
      description:
        "Bring your ideas to life with professional video editing that captures attention. We create polished, engaging videos that enhance your brand’s story.",
      icon: (
        <img
          src={icon1}
          className="w-12 h-12 mb-0 text-teal-700 "
          alt="Video Editing Service"
        />
      ),
      imgAlt: "Video Editing Service",
    },
    {
      title: "Web Development",
      description:
        "Design and develop stunning, user-friendly websites that reflect your brand. We build websites that not only look great but also drive conversions.",
      icon: (
        <img
          src={icon4}
          className="w-12 h-12 mb-0 text-teal-700"
          alt="Web Development Service"
        />
      ),
      imgAlt: "Web Development Service",
    },
  ];

  const FeatureCard = ({ title, description, imgSrc, icon, imgAlt }) => (
    <div className="border border-white  e-card playing flex-shrink-0 w-[300px] md:w-[300px] sm:w-80 lg:w-72 xl:w-96 h-[350px] md:h-[380px] lg:h-[400px] flex flex-col justify-start items-center rounded-md px-4 py-5 text-center shadow-md mx-2 bg-white ">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
  
      <div className="infotop flex flex-col items-center w-full">
        <div className="flex-grow-0 flex items-center justify-center h-[100px] mt-4 mb-4">
          <span className="flex items-center justify-center w-[80px] h-[80px] bg-white rounded-full">
            {icon}
          </span>
        </div>
  
        {/* Text Section */}
        <div className="flex flex-col items-center justify-center px-2  md:px-6 lg-px-8">
          <h3 className="text-white font-bold text-md md:text-lg lg:text-2xl">
            {title}
          </h3>
          <p className="mt-4 text-sm md:text-md lg:text-base text-white">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
  

  const LogoSlider = () => {
    return (
      <div className=" py-20 md:py-2 mx-auto">
        <div className="overflow-hidden">
          {/* Sliding logos container */}
          <div className="flex items-center space-x-20 animate-slide">
            {/* Render logos */}
            {logos.map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Logo ${index + 1}`}
                className="w-36 h-auto filter-white "
              />
            ))}
            {/* Duplicate the logos for infinite scrolling */}
            {logos.map((logo, index) => (
              <img
                key={`duplicate-${index}`}
                src={logo}
                alt={`Logo ${index + 1}`}
                className="w-36 h-auto"
              />
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="mb-0 ">
        <div
          className="min-h-screen "
          style={{
            backgroundImage: `url(${bgteal})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <div className="">
            <Navbar color={" text-teal-950"} />
          </div>
          <div>
            {/* Hero section */}
            <div
              className=" px-0 md:px-2 lg:px-24 text-white pb-52 md:pb-5 lg:pb-2   bg-gradient-to-r from-teal-950 via-teal-800 to-teal-600"
              style={{
                backgroundImage: `url(${bgteal})`,
                backgroundSize: "cover",
                backgroundPosition: "top left",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed", // Fix background movement
              }}
            >
              {/* Hero Section */}
              <section className="h-screen container mx-auto px-8 md:px-0 lg:px-0 pb-20 pt-10 md:pt-5 lg:pt-5 flex flex-col md:flex-row items-center">
                <div className="w-full md:w-1/2 text-left md:text-left lg:mb-10 mb-10 md:mb-0 relative">
                  {/* Circular Gradient Background */}
                  <div className="relative mx-2 md:mx-4 lg:mx-10 z-10">
                    <TypewriterText
                      text=" Driving Digital Success Through Innovative Solutions."
                      className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6"
                    />
                  </div>

                  <p className="text-lg md:text-xl lg:md:text-xl mb-8 mx-2 md:mx-4 lg:mx-10 z-10">
                    We craft personalized digital strategies that amplify your
                    online presence and accelerate growth.
                  </p>
                  <div className="space-y-4 md:space-x-4 md:space-y-0 flex flex-col md:flex-row justify-center md:justify-start mx-2 md:mx-4 lg:mx-10 z-10">
                    <Link to="/about">
                      <button class="px-5 z-30 py-3 bg-white rounded-md text-teal-500 relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-400 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
                        Learn More
                        <span className="ml-2">→</span>
                      </button>
                    </Link>

                    <Link to="/contact">
                      <button class="px-5 z-30 py-3 bg-teal-500 bg-opacity-55 border-teal-50 border rounded-md text-white relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-400 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
                        Get A Quote
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="w-full md:w-1/2 flex justify-center md:justify-end mx-2 md:mx-4 lg:mx-10">
                  <img
                    src={HomeHero}
                    alt="Social Media Management"
                    className="w-full h-auto max-w-sm md:max-w-full pt-0 md:pt-2 lg:pt-0"
                  />
                </div>
              </section>
            </div>

            <div
              style={{
                backgroundImage: `url(${bgwhite})`,
                backgroundSize: "cover",
                backgroundPosition: "top left",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed", // Fix background movement
              }}
            >
              <div className="  pt-14  md:pt-20 lg:pt-24   px-8 md:px-10 lg:px-32 ">
                <LogoSlider />
              </div>
              {/*This is the About section */}
              <div
                ref={aboutRef}
                className={`  px-2 md:px-2 lg:px-24 transition-all  `}
              >
                {/* Hero Section */}
                <section className="container mx-auto px-4 py-2 md:py-10 lg:py-20 flex flex-col md:flex-row items-center ">
                
                
                
                  <div className="lg:flex lg:justify-center lg:items-center w-full md:w-1/2 h-[250px] md:h-[300px] lg:h-[420px] xl:h-[450px]   justify-center md:justify-end mx-0 md:mx-1 lg:mx-2 md:block hidden ">
                    <img
                      src={about}
                      alt="Social Media Management"
                      className={`w-full h-auto max-w-sm md:max-w-full`}
                    />
                  </div>
                  <div
                    ref={aboutRef}
                    className={` w-full md:w-1/2 text-left md:text-left ml-2 md:ml-8 lg:ml-10 md:mr-2 lg:mr-4 mb-10 md:mb-0  text-gray-600 p-8 md:p-10 lg:p-10 xl:p-20 rounded-md  transition-all duration-[2s] ease-in-out transform ${
                      aboutInView
                        ? " scale-100  opacity-100"
                        : "opacity-0 scale-75"
                    }`}
                  >
                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 text-teal-800 ">
                      Why We’re TheBest Match For Your{" "}
                      <span className="font-bold text-teal-500 text-3xl md:text-4xl lg:text-5xl">
                        Business ?
                      </span>
                    </h1>
                    <p className="text-md md:text-base lg:text-lg mb-8 text-teal-30 ">
                      At Solvexa Marketing, we provide comprehensive digital
                      marketing services, including social media, SEO, branding,
                      video editing, and web development. Our expert team
                      combines creativity with data-driven strategies to boost
                      visibility, engage audiences, and drive growth, making us
                      the ideal partner to elevate your business.
                    </p>
                    <div className="space-y-4 md:space-x-4 md:space-y-0 flex flex-col md:flex-row justify-center md:justify-start">
                      <button
                        onClick={() => {
                          window.location.href = "/about";
                        }}
                        class="px-8 z-30 py-3 bg-teal-500 rounded-md text-white relative font-medium after:-z-20 hover:text-white  after:absolute after:h-1 after:w-1 after:bg-teal-400 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg"
                      >
                        About Us
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* This is the features section */}

            <div
              className="bg-gradient-to-br from-teal-950 via-teal-600 to-teal-800"
              style={{
                backgroundImage: `url(${bgteal})`,
                backgroundSize: "cover",
                backgroundPosition: "top left",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed", // Fix background movement
              }}
            >
              <div className="relative pt-2 md:pt-2 lg:pt-2 pb-10 md:pb-8 lg:pb-12">
                <div className="relative">
                  <section
                    id="features"
                    className="relative z-10 block px-4 py-10 md:py-20 md:px-10 bg-transparent text-black"
                  >
                    <div className="relative mx-auto max-w-5xl text-center text-teal-50 mb-4 md:mb-2 lg:mb-2">
                      <h2 className="block w-full text-white font-bold text-3xl md:text-3xl lg:text-4xl">
                        Powering Success with Every Service
                      </h2>
                      <p className="text-lg font-medium mx-auto mt-4 w-full max-w-xl bg-transparent text-center leading-relaxed tracking-wide text-teal-50">
                        Find our Services Below!
                      </p>
                    </div>

                    <div className="mx-auto max-w-7xl px-4 md:px-8 lg:px-10 py-4">
                      <Slider {...settings} className="w-full pb-6 ">
                        {features.map((feature, index) => (
                          <div className="px-2" key={index}>
                            <FeatureCard
                              title={feature.title}
                              description={feature.description}
                              icon={feature.icon}
                              imgAlt={feature.imgAlt}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </section>
                </div>
              </div>

              {/* G2 Award Section */}
              <div className=" py-8 lg:pb-20 md:pb-12 pb-8 px-4 md:px-16 lg:px-32 ">
                <section className="container flex flex-col md:flex-row items-center justify-between bg-white rounded-xl py-4 px-2 mx-auto">
                  <div className="flex items-center">
                    <img
                      src={best1}
                      alt="Award Image"
                      className="w-[150px] sm:w-[250px] md:w-[300px] h-auto mr-2 sm:mr-6 md:mr-0 lg:md:mr-2"
                    />
                    <div>
                      <h1 className="font-semibold text-sm md:text-2xl lg:text-3xl text-teal-950  ">
                        <p>
                          Solvexa is named{" "}
                          <b className="ml-2 text-xl md:text-3xl lg:text-4xl text-teal-600">
                            #1
                          </b>
                        </p>
                        <p className="mt-1">
                          Best Overall Software Product for 2024
                        </p>
                      </h1>
                    </div>
                  </div>

                  <img
                    src={best}
                    alt="Award Image"
                    className="w-[150px] sm:w-[150px] md:w-[300px] lg:w-[300px] h-auto lg:mr-2 hidden md:hidden lg:block"
                  />
                </section>
              </div>
            </div>

            <div
              //  style={{
              //   backgroundImage: `url(${bgwhite})`,
              //   backgroundSize: "cover",
              //   backgroundPosition: "top left",
              //   backgroundRepeat: "no-repeat",
              //   backgroundAttachment: "fixed", // Fix background movement
              // }}
              class={`  w-full transition-all transform duration-[2s] ease-in-out bg-white`}
              ref={statsRef}
            >
              {/* Top-left arrow image */}
              <img
                src={downarrow} // Replace with your image source
                alt="Top Left Arrow"
                className="absolute top-3 left-20 w-40 h-40 hidden lg:flex md:hidden"
                style={{ transform: "rotate(70deg)" }} // Adjust size and position
              />

              {/* Bottom-left arrow image */}
              <img
                src={uparrow} // Replace with your image source
                alt="Bottom Left Arrow"
                className="absolute bottom-0 right-10 w-48 h-48 -rotate-45  hidden lg:flex md:hidden" // Adjust size and position
              />
              <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8  lg:py-20">
                <div class="max-w-5xl mx-auto text-center">
                  <h2
                    class="pb-1 text-3xl md:text-4xl lg:text-4xl font-bold "
                    style={{ color: "#08C7C7" }}
                  >
                    Trusted By Clients
                  </h2>
                  <p class="mt-3 text-lg text-gray-500">
                    We can help you grow your audience and your business, no
                    matter the size.
                  </p>
                </div>
                <dl class="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8">
                  <div class="flex flex-col border border-teal-700  rounded-lg p-10 shadow-lg shadow-gray-400 bg-gradient-to-tr from-teal-50 to-white h-[170px]">
                    <dt class="order-2 mt-2 text-lg leading-6 font-medium text-teal-700">
                      Happy Clients
                    </dt>
                    <dd class="order-1 text-5xl font-extrabold ">
                      {inView && (
                        <CountUp
                          start={0}
                          end={50}
                          duration={2}
                          className="order-1 text-5xl font-extrabold text-teal-700"
                        />
                      )}
                      <p className="inline ml-2 text-teal-700">+</p>
                    </dd>
                  </div>
                  <div class="flex flex-col mt-10 sm:mt-0  border border-teal-700  p-10 rounded-lg  shadow-lg shadow-gray-400 h-[170px] bg-gradient-to-tr from-teal-50 to-white">
                    <dt class="order-2 mt-2 text-lg leading-6 font-medium text-teal-700">
                      Years Of Service
                    </dt>
                    <dd class="order-1 text-5xl font-extrabold text-teal-700">
                      {" "}
                      {inView && (
                        <CountUp
                          start={0}
                          end={10}
                          duration={2}
                          className="order-1 text-5xl font-extrabold text-teal-700"
                        />
                      )}
                      <p className="inline ml-2 text-teal-700">+</p>
                    </dd>
                  </div>
                  <div class="flex flex-col mt-10 sm:mt-0  border border-teal-700 p-10 rounded-lg  shadow-lg shadow-gray-400 h-[170px] bg-gradient-to-tr from-teal-50 to-white ">
                    <dt class="order-2 mt-2 text-lg leading-6 font-medium text-teal-700">
                      Projects
                    </dt>
                    <dd class="order-1 text-5xl font-extrabold text-teal-700">
                      {" "}
                      {inView && (
                        <CountUp
                          start={0}
                          end={150}
                          duration={2}
                          className="order-1 text-5xl font-extrabold text-teal-700"
                        />
                      )}
                      <p className="inline ml-2 text-teal-700">+</p>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>

            <div
              className="bg-gradient-to-br from-teal-950 via-teal-600 to-teal-700 mb-10 "
              style={{
                backgroundImage: `url(${bgteal})`,
                backgroundSize: "cover",
                backgroundPosition: "top left",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed", // Fix background movement
              }}
            >
              <WhyChooseUs />
            </div>
            {/* contact Section */}
            <div
              className={`bg-white   py-6 md:py-8 lg:py-12  text-black mt-0 md:mt-4 lg:mt-4 transition-all transform duration-700 ease-in-out    shadow-sm rounded-lg `}
            >
              <div className="flex flex-col items-center justify-center  text-center">
                {/* Introductory Text */}
                <h2
                  className="text-3xl font-bold  mb-4"
                  style={{ color: "#08C7C7" }}
                >
                  Get in Touch
                </h2>
                <p className="font-normal text-gray-500 mb-6 text-md md:text-lg lg:text-lg px-10">
                  We would love to hear from you! Whether you have a question,
                  feedback, or just want to chat, feel free to reach out to us.
                  Our team is here to assist you.
                </p>

                <button class="px-5 z-30 py-3 bg-teal-500 bg-opacity-90 border-teal-50 border rounded-md text-white relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-400 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
                  <a
                    href="/contact" // Replace with your actual contact page link
                    className=""
                  >
                    Contact Us
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
